/**
 * @docs docs/features/opportunities
 * @adr  ADR-0074
 * @rule A trend page: every published edition the trend appeared in. Never static: the latest edition flips at 06:00 UTC.
 */

import { definePageRoute } from '@common/router/definitions';

import { buildEditionsRouteData, renderEditionsRoute } from './lib/editionsRoute';

export default definePageRoute({
    path: '/:editionPage(business-ideas|trending-domains)/trends/:slug',
    options: { auth: false, layout: false },
    data: buildEditionsRouteData,
    render: renderEditionsRoute,
});
